var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xaoi_img"},[_c('div',{staticClass:"conn",style:({paddingTop:_vm.height})},[_c('div',{staticClass:"pos"},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }